import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => ({
  modalRoot: {
    "& .MuiDialog-paper": {
      maxWidth: 351,
      width: "100%"
    },
    "& .MuiDialogTitle-root": {
      paddingLeft: 20,
      paddingRight: 20,
      "& .MuiTypography-root": {
        fontSize: 18,
        fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
        lineHeight: "23px"
      }
    },
    "& .MuiDialogContent-root": {
      padding: 0
    },
    "& .MuiDialogContent-dividers": {
      borderTop: `1px solid ${theme.palette.text.hint}`
    },
    "& .MuiTableRow-root:nth-child(2n) .MuiTableCell-root": {
      backgroundColor: "rgba(238, 238, 238, 0.5)"
    }
  },
  matchingHorsesBadge: {
    border: "1px solid #998765",
    backgroundColor: "rgba(153, 135, 101, 0.15)",
    color: "rgba(153, 135, 101, 1)",
    [theme.breakpoints.down("xs")]: {
      opacity: 0.05
    }
  },
  tableMatchingHorseRow: {
    "&:hover": {
      cursor: "pointer",
      backgroundColor: "#ececec"
    }
  },
  tableMatchingHorseCell: {
    fontSize: 14,
    padding: "8px 20px"
  },
  tableMatchingHorseRacesCount: {
    width: "10%",
    padding: "8px 4px 8px 20px"
  },
  tableMatchingHorseName: {
    fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
    fontSize: 13,
    overflow: "hidden",
    textOverflow: "ellipsis",
    width: "80%",
    padding: "8px 4px"
  },
  tableMatchingHorsePreferredConditionsType: {
    width: "10%",
    padding: "8px 12px 8px 4px"
  },
  lastRaceIconDetails: {
    width: 32,
    height: 13,
    color: "#48769b",
    position: "relative",
    left: -4
  },
  customIconDetails: {
    width: 32,
    height: 17,
    color: "#998765",
    position: "relative",
    left: -4
  },
  dialogLoader: {
    minHeight: 120
  }
}));
